import React, { Component } from 'react';
import { localize } from 'react-localize-redux';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import { featureEnabled } from 'helpers/ToggleBot';
import { maintenanceTicketStatuses } from 'helpers/constants/Statuses';

export default localize()(
  class TicketStatusIcon extends Component {
    getTicketConfig(defaultCss) {
      const { status, translate } = this.props;

      const vendorStatusToggle = featureEnabled('maintenance.vendor_statuses_and_notifications');

      const statusName = status.toLowerCase();

      let statusClassName = statusName;
      let statusContentName = statusName;

      let content = null;

      switch (statusName) {
        case 'new':
        case 'reviewed':
        case 'scheduled':
        case 'fixing':
        case 'fixed':
        case 'closed':
          break; //don't do anything

        case maintenanceTicketStatuses.PROPOSED_SCHEDULED_DATE:
          statusClassName = 'reviewed';
          statusContentName = 'reviewed';
          break;
        case 'acknowledged':
        case 'contractor needed review':
        case 'parts needed review':
          statusClassName = 'scheduled';
          statusContentName = vendorStatusToggle ? 'assigned' : 'scheduled';
          break;
        case 'assigned':
          statusClassName = 'scheduled';
          statusContentName = 'assigned';
          break;

        case 'contractor needed':
        case 'parts needed':
        case 'deferred':
        case 'vendor_other':
        case 'vendor_ongoing':
        case 'vendor_cancelled':
        case 'additional review required':
          statusClassName = 'partsneeded';
          statusContentName = 'additionalWorkRequired';
          break;

        case 'cancelled_dup':
        case 'cancelled':
        case 'cancelled_no_res':
          statusClassName = 'cancelled';
          statusContentName = 'cancelledNoIssue';
          break;

        case 'contact tenant':
          statusClassName = 'unhappytenant';
          content = (
            <TenantResidentVerbiageHelper
              translatedTenant={translate('maintenanceStatus.unhappyTenant')}
              translatedResident={translate('maintenanceStatus.unhappyResident')}
            />
          );
          break;
        case 'auto_deferred':
          statusClassName = 'partsneeded';
          statusContentName = 'unexpectedDelay';
          break;

        default:
          statusClassName = 'new';
          statusContentName = 'new';
      }

      const ticketConfig = {
        className: `${defaultCss} ${statusClassName}`,
        content: content || translate(`maintenanceStatus.${statusContentName}`),
      };

      return ticketConfig;
    }

    render() {
      let cssClass = 'tenant_ticket_status_label_title';
      if (this.props.isTableLabel) {
        cssClass = 'ticket_status_label_title';
      }

      cssClass += ' small';

      const ticketConfig = this.getTicketConfig(cssClass);

      return <span className={ticketConfig.className}>{ticketConfig.content}</span>;
    }
  }
);
